'use client';

import { useTranslations } from 'next-intl';

import { LazyImageLightbox, useImageLightbox } from '@/components/ui/lazy-image-lightbox';
import { cn } from '@/lib/utils';

interface MarkdownImageProps {
  src?: string;
  alt?: string;
  className?: string;
}

export function MarkdownImage({ src, alt, className }: MarkdownImageProps) {
  const t = useTranslations('imageGallery');
  const { lightboxProps, openLightbox, createKeyHandler } = useImageLightbox();

  if (!src) return null;

  return (
    <>
      <span
        role="button"
        tabIndex={0}
        className={cn(
          'aui-md-img inline-block cursor-pointer rounded-lg border border-border/20 shadow-sm outline-none focus-visible:ring-[3px] focus-visible:ring-ring',
          className,
        )}
        onClick={() => openLightbox(0)}
        onKeyDown={createKeyHandler(0)}
        aria-label={alt || t('viewFullSize')}
      >
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={src}
          alt={alt ?? ''}
          className="h-auto max-h-48 max-w-72 rounded-lg object-contain sm:max-h-56"
          loading="lazy"
        />
      </span>
      <LazyImageLightbox images={[src]} {...lightboxProps} />
    </>
  );
}
